<template>
  <div>
    <navbar fixed back bg>
      <span slot="title">注册</span>
    </navbar>
    <div class="page-content">
      <form class="custom-form" @submit.prevent="doSubmit" novalidate="novalidate">
        <div class="cell-group">
          <div class="input-cells">
            <div class="label-cell">
              <label>手机号码</label>
            </div>
            <div class="input-cell">
              <input type="tel" v-model="phone" class="form-control">
            </div>
          </div>
          <div class="input-cells">
            <div class="label-cell">
              <label>图形验证码</label>
            </div>
            <div class="input-cell">
              <input type="text" v-model="captText" class="form-control">
            </div>
            <div class="help-cell">
              <a href="javascript:;" @click="updateCapt"><img :src="captUrl"></a>
            </div>
          </div>
          <div class="input-cells">
            <div class="label-cell">
              <label>短信验证码</label>
            </div>
            <div class="input-cell">
              <input type="text" v-model="phoneCapt" class="form-control">
            </div>
            <div class="help-cell">
              <button type="button" class="btn-code" @click="getPhoneCapt" :disabled="btnDisable">{{btnText}}</button>
            </div>
          </div>
          <div class="input-cells">
            <div class="label-cell">
              <label>登录密码</label>
            </div>
            <div class="input-cell">
              <input type="password" v-model="password" class="form-control">
            </div>
          </div>
        </div>
        <div class="btn-group">
          <button type="submit" class="btn-submit">注册</button>
        </div>
        <div class="protocol-group">
          点击注册，即代表您已同意伟嘉安捷
          <router-link class="protocol" to="/auth/protocol">《注册协议》</router-link>
        </div>
      </form>
      <div class="bottom-group">
        <div class="bottom">
          已有账号！现在去 <router-link class="sign" to="/auth/login" replace>登录</router-link>
        </div>
      </div>
    </div>
    <toast :show="toastShow" :text="toastText" @hidden="toastShow=false"></toast>
    <spinner :show="loading"></spinner>
  </div>
</template>

<script>
  import Navbar from 'components/navbar/navbar'
  import Toast from 'components/toast/toast'
  import Spinner from 'components/spinner/spinner'

  export default {
    data () {
      return {
        loading: false,
        toastShow: false,
        toastText: '',
        btnDisable: false,
        btnText: '获取验证码',
        captUrl: '',
        phone: '',
        password: '',
        captText: '',
        phoneCapt: ''
      }
    },
    components: {
      Navbar,
      Spinner,
      Toast
    },
    created () {
      this.updateCapt()
    },
    methods: {
      updateCapt () {
        this.captUrl = this.$cache.updateCapt()
      },
      doSubmit () {
        if (this._validate()) {
          let vm = this
          let params = {
            phone: vm.phone,
            captId: this.$cache.getCaptId(),
            captText: vm.captText,
            phoneCapt: vm.phoneCapt,
            password: this.$md5(vm.password)
          }
          let url = '/register.jhtml'
          if (this.$from().isInner) {
            url = '/wxRegister.jhtml'
            let time = Date.now()
            let cache = this.$parseParams(this.$cache.getCache() || '')
            params = this.$assign({}, params, cache, {
              time,
              sign: this.$md5(cache.appID + cache.msgId + time)
            })
          }
          this.loading = true
          this.$ajax({
            url,
            params,
            done (o, p, r) {
              vm.$cache.setUserToken(vm.$assign(o, {
                phone: vm.phone
              }))
              vm.$dialog({
                content: r.msg,
                onHide () {
                  let backurl = vm.$route.query.backurl
                  if (backurl) {
                    window.location.href = backurl
                    return
                  }
                  if (o.status === 0) {
                    vm.$router.replace('/auth/authentication')
                  } else {
                    vm.$router.replace('/user')
                  }
                }
              })
            },
            fail (msg) {
              vm.$dialog(msg)
              vm.updateCapt()
            },
            always () {
              vm.loading = false
            }
          })
        }
      },
      getPhoneCapt () {
        if (this._validate(true)) {
          let vm = this
          this.loading = true
          this.$ajax({
            url: '/sendPhoneCaptcha.jhtml',
            params: {
              phone: vm.phone,
              captId: vm.$cache.getCaptId(),
              captText: vm.captText,
              business: '1001'
            },
            done (info, page, res) {
              vm.$dialog(res.msg)
              vm.countdown()
            },
            fail (msg) {
              vm.$dialog(msg)
              vm.updateCapt()
            },
            always () {
              vm.loading = false
            }
          })
        }
      },
      countdown (t) {
        if (t === undefined) {
          t = 60
        }
        clearTimeout(this._timer)
        if (--t > 0) {
          this.btnText = `${t}秒后重试`
          this.btnDisable = true
          this._timer = setTimeout(() => {
            this.countdown(t)
          }, 1000)
        } else {
          this.btnText = '重新获取'
          this.btnDisable = false
        }
      },
      _validate (isBreak) {
        if (!this.phone) {
          this.toastText = '请输入手机号码'
          return !(this.toastShow = true)
        }
        if (!/^1\d{10}$/.test(this.phone)) {
          this.toastText = '请输入正确的手机号码'
          return !(this.toastShow = true)
        }
        if (!this.captText) {
          this.toastText = '请输入图形验证码'
          return !(this.toastShow = true)
        }
        if (isBreak) {
          return isBreak
        }
        if (!this.phoneCapt) {
          this.toastText = '请输入短信验证码'
          return !(this.toastShow = true)
        }
        if (!this.password) {
          this.toastText = '请输入登录密码'
          return !(this.toastShow = true)
        }
        if (/^\d+$/.test(this.password) || /^[a-zA-Z]+$/.test(this.password) || !/^\w{6,16}$/.test(this.password)) {
          this.toastText = '密码应为6-16位字母数字的组合'
          return !(this.toastShow = true)
        }
        if (/\s/.test(this.password)) {
          this.toastText = '密码不能包含空格'
          return !(this.toastShow = true)
        }
        return true
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../common/css/mixmin'


  .cell-group
    margin px2rem(20) 0 px2rem(60)
    box-shadow 0 px2rem(10) px2rem(15) rgba(171,185,197, 1)

  .btn-group
    width 100%
    padding 0 px2rem(80)
    .btn-submit
      width 100%
      height px2rem(80)
      font-size px2rem(32)
      color #fff
      letter-spacing px2rem(4)
      border none
      border-radius px2rem(8)
      background-color #60c9c8
      box-shadow 0 0 px2rem(4) rgba(18,119,163, .75)

  .protocol-group
    margin-top px2rem(20)
    font-size px2rem(24)
    color #7f868c
    text-align center
    .protocol
      color #f56966
      text-decoration underline

  .bottom-group
    margin-top px2rem(280)
    width 100%
    font-size px2rem(24)
    color #7f868c
    text-align center
    .sign
      font-size px2rem(32)
      color #275482
</style>



// WEBPACK FOOTER //
// register.vue?2a4a2a06